import React, { useContext } from 'react'
import { FileEarmarkText } from 'react-bootstrap-icons'
import { SharedCampaignContext } from '../../../../../contexts/Advertiser/SharedCampaignContext'
import { useSidebarCollapse } from '../../../../../contexts/SidebarCollapseContext'

const InfluencerMainHeader = () => {
  const { campaign } = useContext(SharedCampaignContext)
  const { isCollapsed } = useSidebarCollapse()

  return (
    <div className={`bg-white dark:bg-rb-dark-mode pt-12 pr-12 w-full border-2 border-rb-widget-border dark:border-rb-dark-mode-lighter flex justify-between items-center transition-all duration-300 ${isCollapsed ? 'pl-20' : 'pl-60'}`}>
      <div className="flex items-center gap-4 py-5">
        <span className='rounded-lg p-4 border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter text-white' style={{backgroundColor: campaign.theme_color}}>{campaign.name.slice(0,2).toUpperCase()}</span>
        <div>
          <p className='text-rb-lighter-grey dark:text-gray-400'>{campaign.name}</p>
          <h1 className='text-2xl dark:text-white'>Influencers - Main page</h1>
        </div>
      </div>
      <div className="flex items-center gap-5 py-5 text-xs">
        <div className="flex gap-2 items-center bg-gray-100 dark:bg-rb-dark-mode-lighter rounded-full p-1 dark:text-white">
          <div className="h-2 w-2 rounded-full" style={{ backgroundColor: '#2563EB'}} />
          <span>External/Visible</span>
        </div>
        <div className='flex gap-2 items-center bg-gray-100 dark:bg-rb-dark-mode-lighter rounded-full p-1 dark:text-white'>
          <div className="h-2 w-2 rounded-full" style={{ backgroundColor: '#EAB308' }} />
          <span>Internal/Not visible</span>
        </div>
        <button
          className='flex gap-2 items-center bg-rb-green rounded-lg p-2 opacity-30 dark:text-white'
          disabled={true}
          // onClick={}
        >
          <FileEarmarkText className='text-white font-bold'/>
          <span className='text-white font-bold'>Export</span>
        </button>
      </div>
    </div>
   );
}

export default InfluencerMainHeader;
